export default __webpack_public_path__ + "35bdd6cc6ac8a4708c958823fcb6935e.png";